import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'page-layout',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    main: {},
    header: {},
    content: {},
  }),
  options
);

export default useStyles;
